import React from 'react';

import { BORDER_MAIN, COLOR_WEEKEND, WEEKEND_DAYS_2 } from '../const';
import { CUSTOM_WEEK_START } from '../functions';

interface ICalendarGridColumn {
    rowHeight: number;
    countColumn: number;
    children?: React.JSX.Element[];
}

const CalendarGridColumnWeek: React.FC<ICalendarGridColumn> = ({ countColumn, rowHeight, children = [] }) => {
    const getStyle = (index: number): React.CSSProperties => ({
        position: 'absolute',
        top: 0,
        left: `calc(100% / ${countColumn} * ${index})`,
        height: rowHeight,
        width: `calc(100% / ${countColumn} - ${index !== 6 ? 1 : 0}px)`,
        borderRight: BORDER_MAIN,
    });

    const workDay = (index: number) => (
        <div
            style={{
                ...getStyle(index),
                // backgroundColor: 'red',
            }}
        >
            {children[index]}
        </div>
    );

    const weekendDay = (index: number) => (
        <div
            style={{
                ...getStyle(index),
                backgroundColor: COLOR_WEEKEND,
                opacity: 0.1,
            }}
        ></div>
    );

    return (
        <div style={{ height: rowHeight }}>
            {Array.from({ length: countColumn }).map((_, index) => {
                const shiftedIndex = (index + CUSTOM_WEEK_START) % 7;

                const isWeekend = WEEKEND_DAYS_2.has(shiftedIndex);

                return (
                    <div key={index}>
                        {isWeekend && weekendDay(index)}
                        {workDay(index)}
                    </div>
                );
            })}
        </div>
    );
};

export default CalendarGridColumnWeek;
